import { render, staticRenderFns } from "./DocumentsValidation.vue?vue&type=template&id=16625db8&scoped=true&"
import script from "./DocumentsValidation.vue?vue&type=script&lang=ts&"
export * from "./DocumentsValidation.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsValidation.vue?vue&type=style&index=0&id=16625db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16625db8",
  null
  
)

export default component.exports